import { useContext } from 'react';
import { SnackbarContext } from '../contexts/SnackbarProvider';

const useSnackbar = () => {
  const { toast, addSnackbar, removeSnackbar } = useContext(SnackbarContext);
  return { toast, addSnackbar, removeSnackbar };
};

export default useSnackbar;
